/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */
import * as _ from 'lodash';

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SourceService {
  private cachedSources: any[] = [];
  private cachedDomains: any[] = [];

  constructor(private http: HttpClient) { }

  getSources(minimum: number = 3): Observable<any> {
    if (this.cachedSources.length > 0) {
      return Observable.of(this.cachedSources);
    }

    return this.http
      .get(
        `/api/v1/source?min=${minimum}`
      )
      .map((response: any) => {
        this.cachedSources = response || [];
        return this.cachedSources
    });
  }

  getDomains(): Observable<any> {
    if (this.cachedDomains.length > 0) {
      return Observable.of(this.cachedDomains);
    }

    return this.getSources(0).map(sources => {
      this.cachedDomains = _.uniq(_.map(sources, (s: any) => s.domain));
      return this.cachedDomains;
    });


  }

  saveSource(emailAddress: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/source`,
        JSON.stringify({ email_address: emailAddress })
      )
      .map((response: any) => {
        this.clearCache();
        return response;
      });
  }

  clearCache() {
    this.cachedSources = [];
    this.cachedDomains = [];
  }
}



// WEBPACK FOOTER //
// ./client/app/services/source.service.ts